import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { BrowserRouter } from 'react-router-dom'
import App from './App.js'
import './styles.css'

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  // Fail loudly at boot. A dashboard that renders without auth configured
  // would look like it works and then 401 on every call.
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is not set')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      // Without these, an OAuth sign-in has nowhere to come back to and Clerk
      // strands the user on its own accounts.dev/default-redirect page. The
      // redirect-back is the part OAuth needs; the password flow never leaves
      // the page, which is why this only showed up with "Continue with Google".
      // "Fallback" rather than "Force" so a deep link the user was actually
      // heading for still wins over the dashboard root.
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </React.StrictMode>,
)
